import { render, staticRenderFns } from "./ArtubeLeague.vue?vue&type=template&id=b34841b2&"
import script from "./ArtubeLeague.vue?vue&type=script&lang=js&"
export * from "./ArtubeLeague.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports